import React from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemIcon from "@mui/material/ListItemIcon";
import MoveDownIcon from "@mui/icons-material/MoveDown";

const SuperUserContextMenu = ({
  buildEnv,
  regionName,
  vectorType,
  onMoveDeviceEnv,
  handleClose,
  contextMenuEvent,
  onChangeDeviceVectorType,
  onChangeDeviceRegion,
  onChangeHardwareId,
}) => {
  return (
    <Menu
      open={contextMenuEvent !== null}
      onClose={handleClose}
      anchorReference="anchorPosition"
      anchorPosition={
        contextMenuEvent !== null
          ? { top: contextMenuEvent.mouseY, left: contextMenuEvent.mouseX }
          : undefined
      }
    >
      <MenuItem onClick={onMoveDeviceEnv}>
        <ListItemIcon>
          <MoveDownIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText>Move env (From {buildEnv})</ListItemText>
      </MenuItem>
      <MenuItem onClick={onChangeDeviceVectorType}>
        <ListItemIcon>
          <MoveDownIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText>Change Vector Type (From {vectorType})</ListItemText>
      </MenuItem>
      <MenuItem onClick={onChangeDeviceRegion}>
        <ListItemIcon>
          <MoveDownIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText>Change Region (From {regionName})</ListItemText>
      </MenuItem>
      <MenuItem onClick={onChangeHardwareId}>
        <ListItemIcon>
          <MoveDownIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText>Change Hardware Id</ListItemText>
      </MenuItem>
    </Menu>
  );
};

export default SuperUserContextMenu;
